export function groupCountries(data) {
    const hasGrouping = data.some((item) => item.group);
    if (!hasGrouping) {
        return data;
    }
    return data.reduce((acc, { group, value, label }) => {
        if (group) {
            const existingGroup = acc.find((g) => g.group === group);
            const newItem = { value, label };
            if (existingGroup) {
                existingGroup.items.push(newItem);
            }
            else {
                acc.push({ group, items: [newItem] });
            }
        }
        return acc;
    }, []);
}
//# sourceMappingURL=countries.js.map